import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { postCreateDiscount } from "../../api/Discounts"; 
import toast from "react-hot-toast";
import LoadingTablePage from "../LoadingTablePage";
import DiscountForm from "../../components/discount/DiscountForm";

const CreateDiscountPage = () => {
  const { t } = useTranslation();
  const { getAccessToken } = useAuth(); 

  const navigate = useNavigate();
  const [loading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]); 

  const [discount, setDiscount] = useState({
    name: "", 
    description: "", 
    discountValueType: "", 
    discountConditionType: "",
    isCalculatedPerChargingSite: false, 
    minKwh: "0",
    maxKwh: "0",
    discountValue: "0",
    startDateTimeUtc: null,
    endDateTimeUtc: null
  });

  const handleInputChange = (key, value) => {
    setHasChanges(true);
    setDiscount((prev) => ({ ...prev, [key]: value }));
  };

  const handleCreateChargingDiscount = async () => {
    const toastId = toast.loading(t("toast.creating", { entity: t("entity.discount") }));  
    
    const requiredFields = ["name", "discountValueType", "discountConditionType", "startDateTimeUtc"];
    
    const missingFields = requiredFields.filter((field) => {
      const value = discount[field];
      return value === "" || value === undefined || value === null;
    });
    
    setInvalidFields(missingFields);
    
    if (missingFields.length > 0) {
      toast.error(t("common.pleaseFillRequiredFields", { fields: missingFields.join(", ") }), {
        id: toastId,
      });
      return;
    }   
   
    try {
      const accessToken = await getAccessToken();
      if(!discount.startDateTimeUtc) {
        discount.startDateTimeUtc = new Date().toISOString();
      }
      const newDiscount = await postCreateDiscount(discount, accessToken);
      
      toast.success(t("toast.created", { entity: t("entity.discount") }), { id: toastId });

      navigate(`/discount/${newDiscount.discountPublicId}`);
      
    } catch (error) {
        toast.error(error?.message || t("toast.failedCreate", { entity: t("entity.discount") }), {
        id: toastId,
      });
    } 
  };

  const navigateBack = () => {
    if (navigate.length > 1) {
      navigate(-1);
    } else {
      navigate("/discounts");
    }
  }

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute inset-0 pointer-events-none">
            <LoadingTablePage title={t("nav.discounts")} loading={loading} />
          </div>

          <div className={`${loading ? "loading" : ""} page-content`}>
            <div className="flex flex-row items-center pb-4">
              <button
                onClick={() => navigateBack()}
                className="text-black flex"
              >
                <FontAwesomeIcon icon={faArrowLeft} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4 ">{t("pages.createDiscount")}</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigateBack()}
                >
                  {t("common.cancel")}
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!discount?.name && !hasChanges}
                  onClick={handleCreateChargingDiscount}
                >
                  {t("common.save")}
                </button>
              </div>
            </div>

            <DiscountForm
              discount={discount}
              handleInputChange={handleInputChange}
              invalidFields={invalidFields}
              setInvalidFields={setInvalidFields}
            />
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateDiscountPage;
